export enum ModerationCommand {
    MUTE_AUDIO = 'mute_microphone_command',
    MUTE_VIDEO = 'mute_camera_command',
    MUTE_DESKTOP = 'mute_desktop_command',
    MUTE_RECORDING = 'mute_recording_command',
    MUTE_RECORDING_WITHOUT_REMOVAL = 'mute_recording_without_removal_command',
}

export enum ModerationSourceType {
    PEER_SOURCE = 'peer_source',
    USER_SOURCE = 'user_source',
}

interface ModerationPeerSource {
    type: ModerationSourceType.PEER_SOURCE;
    peer_id: string;
}

interface ModerationUserSource {
    type: ModerationSourceType.USER_SOURCE;
    uid: string;
}

export type ModerationSource = ModerationPeerSource | ModerationUserSource;

export interface ModerationCommandObject {
    command: {
        type: ModerationCommand;
    };
    source: ModerationSource;
}

export interface MutePeerRecordingPayload {
    peerId: string;
    withoutRemoval?: boolean;
}
